import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTHorizontalStack from "../../_common/_containers/HorizontalStack/index"
import NRTFormInput from "../../_common/_form/FormInput/index"
import NRTButton from "../../_common/_buttons/Button/index"
import NRTFormStateManager from "../../_common/_form/FormStateManager/index"


class NRTBannerForm extends Component {

    state = {
        form: null
    }


    onFormChange = (form) => {
        this.setState({form})
    }

    onSave = () => this.props.onSave(this.state.form.values)



    render() {

        const {banner} = this.props

        if (!banner)
            return null

        return (
            <div className="slide-details-form">

                <NRTFormStateManager ref={f => this.form = f}
                                     onStateChange={this.onFormChange}>
                    <NRTHorizontalStack fractions={[1]}>

                        <NRTFormInput label={'Título'}
                                      name={'title'}
                                      value={banner.title}/>

                        <NRTFormInput label={'Subtítulo'}
                                      name={'subtitle'}
                                      value={banner.subtitle}/>

                        <NRTFormInput label={'Texto do botão'}
                                      name={'buttonTitle'}
                                      value={banner.buttonTitle}/>

                        <NRTFormInput label={'Link do botão'}
                                      name={'link'}
                                      value={banner.link}/>

                        <NRTFormInput label={'Centralizar conteúdo'}
                                      name={'center'}
                                      type={'switch'}
                                      switchType={'primary'}
                                      value={banner.center}/>

                        <NRTFormInput name={'overlay'}
                                      label={'Filtro'}
                                      type={'select'}
                                      value={banner.overlay}
                                      customProps={{
                                          options: [
                                              {
                                                  value: 10,
                                                  label: ' - '
                                              },
                                              {
                                                  value: 0,
                                                  label: 'Escurecer'
                                              },
                                              {
                                                  value: 1,
                                                  label: 'Clarear'
                                              },
                                          ]
                                      }}
                        />

                        <NRTButton onClick={this.onSave}>
                            Salvar
                        </NRTButton>

                    </NRTHorizontalStack>


                </NRTFormStateManager>


            </div>
        )
    }
}

NRTBannerForm.propTypes = {
    onSave: PropTypes.func.isRequired,
    banner: PropTypes.object,
}

export default NRTBannerForm



// WEBPACK FOOTER //
// ./src/components/_admin/BannerForm/index.js